export const resourceTypeWithOperatorAutoCompete: Set<string> = new Set([
  "instance_type",
  "region",
  "name",
  "namespace",
  "workload_name",
  "workload_type",
  "architecture",
]);
